import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import "./App.css";
import { ToastContainer } from "react-toastify";
import Login from "./components/Auth/Login";
import Register from "./components/Auth/Register";
import Verify from "./components/Auth/Verify";
// import InitAmadeusToken from "./components/InitAmadeusToken";
import Home from "./components/Home/Home";
import Flights from "./components/Flights/Flights";
import FlightCheckout from "./components/FlightCheckout/FlightCheckout";
import Hotels from "./components/Hotels/Hotels";
import HotelAvailibility from "./components/HotelAvailibility/HotelAvailibility";
import HotelCheckout from "./components/HotelCheckout/HotelCheckout";
import PrivacyPolicy from "./components/PrivacyAndTerms/PrivacyPolicy";
import TermsCondition from "./components/PrivacyAndTerms/TermsCondition";
import ContactUs from "./components/ContactUs/ContactUs";
import Partnerships from "./components/Partnerships/Partnerships";
import AboutUs from "./components/AboutUs/AboutUs";
import MainPage from "./components/UserDashboard/MainPage/MainPage";
import FlightDetails from "./components/UserDashboard/FlightDetails/FlightDetails";
import PaymentMethods from "./components/UserDashboard/PaymentMethods/PaymentMethods";
import SupportPage from "./components/UserDashboard/SupportPage/SupportPage";
import PaymentHistory from "./components/UserDashboard/PaymentHistory/PaymentHistory";
import HotelDetails from "./components/UserDashboard/HotelDetails/HotelDetails";
import UserInformation from "./components/AdminDashboard/MainPage/MainPage";
import AdminLogin from "./components/AdminDashboard/Auth/Login";
import OrderManagement from "./components/AdminDashboard/OrderManagement/OrderManagement";
import PricingManagement from "./components/AdminDashboard/PricingManagement/PricingManagement";
import ArticleManagement from "./components/AdminDashboard/ArticleManagement/ArticleManagement";
import AddArticleManagement from "./components/AdminDashboard/ArticleManagement/AddArticleSection/AddArticleManagement";
import EditArticleManagement from "./components/AdminDashboard/ArticleManagement/EditArticleSection/EditArticleManagement";
import ActivationSteps from "./components/AdminDashboard/ActivationSteps/ActivationSteps";
import AddActivationSteps from "./components/AdminDashboard/ActivationSteps/AddActivationStepsSection/AddActivationStepsSection";
import EditActivationSteps from "./components/AdminDashboard/ActivationSteps/EditActivationSteps/EditActivationSteps";
import DealsManagement from "./components/AdminDashboard/DealsManagement/DealsManagement";
import UserAccessManagement from "./components/AdminDashboard/UserAccessManagement/UserAccessManagement";
import CreateUserAccess from "./components/AdminDashboard/CreateUserAccess/CreateUserAccess";
import MerchantManagement from "./components/AdminDashboard/MerchantManagement/MerchantManagement";
import MerchantDetails from "./components/AdminDashboard/MerchantDetails/MerchantDetails";
import ListingDetails from "./components/AdminDashboard/ListingDetails/ListingDetails";
import CommissionConfiguration from "./components/AdminDashboard/CommissionConfiguration/CommissionConfiguration";
import Esim from "./components/Esim/Esim";
import PaymentStep from "./components/Esim/PaymentStep/PaymentStep";
import EsimDetailsPage from "./components/Esim/EsimDetailsPage/EsimDetailsPage";
import HelpCenter from "./components/HelpCenter/HelpCenter";
import MyProfile from "./components/Profile/MyProfile";
import MyBookings from "./components/MyBookings/MyBookings";
import ReferralRegister from "./components/Auth/ReferralRegister";
import GlobalPopup from "./components/GlobalPopup/GlobalPopup";
import { EsimBookingDetailPage } from "./components/MyBookings/BookingDetail/EsimBookingDetailPage";
import ResetPassowrd from "./components/Auth/ResetPassword";
import CNY88 from "./components/Campaign/CNY88";
import Marchholiday3 from "./components/Campaign/Marchholiday3";
import DownloadCta from "./components/DownloadCTA/DownloadCta";
import { FlightsBookingDetailPage } from "./components/MyBookings/BookingDetail/FlightsBookingDetailPage";
import EsimShare from "./components/Campaign/esimShare";
import EsimLandingPage from "./components/SeoLanding/EsimLandingPage";
import GiveawayRedirect from "./components/GiveawayRedirect/GiveawayRedirect";
import AppLinkRedirect from "./components/AppLinkRedirect/AppLinkRedirect";
import {
  DestinationPage,
  GuidePage,
  NotFoundPage,
  RegisteredPublicPage,
} from "./components/SeoLanding/PublicContentPage";
import RouteAnalytics from "./analytics/routeAnalytics";
import DealDetailPage from "./components/Deals/DealDetailPage";
import CartPage from "./components/Cart/CartPage";
import CartCheckoutPage from "./components/Cart/CartCheckoutPage";
import CartFloatingButton from "./components/Cart/CartFloatingButton";
import { CartProvider } from "./components/Cart/CartContext";
import ThingsToDoHome from "./components/ThingsToDo/ThingsToDoHome";
import ThingsToDoDetail from "./components/ThingsToDo/ThingsToDoDetail";
import ThingsToDoCheckout from "./components/ThingsToDo/ThingsToDoCheckout";
import ThingsToDoSearch from "./components/ThingsToDo/ThingsToDoSearch";
import AirportLoungesPage from "./components/AirportLounges/AirportLoungesPage";
import AirportLoungeDetailPage from "./components/AirportLounges/AirportLoungeDetailPage";
import MaintenanceGate from "./components/Maintenance/MaintenanceGate";

const ConditionalGlobalPopup = () => {
  const { pathname } = useLocation();

  const isAppLinkFallback =
    pathname.startsWith("/giveaway/") ||
    /^\/[a-z0-9]+(?:-[a-z0-9]+)*\/?$/.test(pathname) ||
    pathname.startsWith("/dealsforyou/") ||
    pathname === "/cart" ||
    pathname.startsWith("/cart/") ||
    pathname === "/flight-checkout" ||
    pathname.startsWith("/moments/") ||
    pathname.startsWith("/things-to-do") ||
    /^\/esim\/[A-Za-z]{2}(?:\/plans\/[^/]+)?\/?$/.test(pathname) ||
    /^\/airport-lounges\/[^/]+\/?$/.test(pathname);

  if (isAppLinkFallback) return null;
  return <GlobalPopup />;
};

const EsimDestinationRoute = () => {
  const { destinationSlug = "" } = useParams();

  return /^[A-Za-z]{2}$/.test(destinationSlug)
    ? <AppLinkRedirect />
    : <DestinationPage />;
};

function App() {
  return (
    <>
      <ToastContainer autoClose={5000} />
      <Router>
        <MaintenanceGate>
          <CartProvider>
          <RouteAnalytics />
          {/* <InitAmadeusToken> */}
          <Routes>
          <Route path="/" element={<Home />} />
          {/* Hotel Routes */}
          {/* <Route path="/hotels" element={<Hotels />} />
          <Route path="/hotels-availibility" element={<HotelAvailibility />} />
          <Route path="/hotel-checkout" element={<HotelCheckout />} /> */}
          {/* Flight Routes */}
          <Route path="/flights" element={<Flights />} />
          <Route path="/flight-checkout" element={<FlightCheckout />} />
          {/* Auth Routes */}
          <Route path="/esim" element={<Esim />} />
          <Route path="/travel-esim" element={<Navigate to="/guides/travel-esim-guide" replace />} />
          <Route path="/esim/singapore" element={<EsimLandingPage destinationKey="singapore" />} />
          <Route path="/esim/japan" element={<EsimLandingPage destinationKey="japan" />} />
          <Route path="/esim/malaysia" element={<EsimLandingPage destinationKey="malaysia" />} />
          <Route path="/esim/thailand" element={<EsimLandingPage destinationKey="thailand" />} />
          <Route path="/esim/vietnam" element={<EsimLandingPage destinationKey="vietnam" />} />
          <Route path="/esim/taiwan" element={<EsimLandingPage destinationKey="taiwan" />} />
          <Route path="/esim/hong-kong" element={<EsimLandingPage destinationKey="hong-kong" />} />
          <Route path="/esim/australia" element={<EsimLandingPage destinationKey="australia" />} />
          <Route path="/esim/united-states" element={<EsimLandingPage destinationKey="united-states" />} />
          <Route path="/esim/south-korea" element={<EsimLandingPage destinationKey="south-korea" />} />
          <Route path="/esim/indonesia" element={<EsimLandingPage destinationKey="indonesia" />} />
          <Route path="/esim/united-arab-emirates" element={<EsimLandingPage destinationKey="united-arab-emirates" />} />
          <Route path="/esim/plan-details" element={<EsimDetailsPage />} />
          <Route path="/esim/payment-step" element={<PaymentStep />} />
          <Route path="/esim/regions/:destinationSlug" element={<DestinationPage regional />} />
          <Route path="/esim/:destinationSlug/plans/:planId" element={<AppLinkRedirect />} />
          <Route path="/esim/:destinationSlug" element={<EsimDestinationRoute />} />
          <Route path="/things-to-do" element={<ThingsToDoHome />} />
          <Route path="/things-to-do/checkout" element={<ThingsToDoCheckout />} />
          <Route path="/things-to-do/search" element={<ThingsToDoSearch />} />
          <Route path="/things-to-do/:id" element={<ThingsToDoDetail />} />
          <Route path="/airport-lounges" element={<AirportLoungesPage />} />
          <Route path="/airport-lounges/search" element={<AirportLoungesPage />} />
          <Route path="/airport-lounges/:loungeId" element={<AirportLoungeDetailPage />} />
          <Route path="/moments/post/:postId" element={<AppLinkRedirect />} />
          <Route path="/moments/profile/:userId" element={<AppLinkRedirect />} />
          <Route path="/guides" element={<RegisteredPublicPage pageKey="guides" />} />
          <Route path="/guides/:guideSlug" element={<GuidePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/referral-signup" element={<ReferralRegister />} />
          <Route path="/referral-signup/:referralCode" element={<ReferralRegister />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/resetPassword" element={<ResetPassowrd />} />
          {/* HelpCenter Routes */}
          <Route path="/help-center" element={<HelpCenter />} />
          {/* Other Routes */}
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/partnerships" element={<Partnerships />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsCondition />} />
          <Route path="/cny88" element={<CNY88 />} />
          <Route path="/Marchholiday3" element={<Marchholiday3 />} />
          <Route path="/download" element={<DownloadCta />} />
          <Route path="/giveaway/:slug" element={<GiveawayRedirect />} />
          <Route path="/dealsforyou/:shareSlug" element={<DealDetailPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/cart/checkout" element={<CartCheckoutPage />} />
          {/* User Dashboard Routes */}
          <Route path="/user-dashboard" element={<MainPage />} />
          <Route path="/flight-details" element={<FlightDetails />} />
          <Route path="/hotel-details" element={<HotelDetails />} />
          <Route path="/payments" element={<PaymentMethods />} />
          <Route path="/payment-history" element={<PaymentHistory />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/my-profile" element={<MyProfile />} />
          <Route path="/my-bookings" element={<MyBookings />} />
          <Route path="/my-bookings/esim/:bookingId" element={<EsimBookingDetailPage />} />
          <Route path="/my-bookings/flights/:bookingId" element={<FlightsBookingDetailPage />} />
          {/* Admin Dashboard Routes */}
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/user-information" element={<UserInformation />} />
          <Route path="/order-management" element={<OrderManagement />} />
          <Route path="/pricing-management" element={<PricingManagement />} />
          <Route path="/article-management" element={<ArticleManagement />} />
          <Route path="/add-article" element={<AddArticleManagement />} />
          <Route path="/edit-article/:id" element={<EditArticleManagement />} />
          <Route path="/activation-steps" element={<ActivationSteps />} />
          <Route path="/add-activation-steps" element={<AddActivationSteps />} />
          <Route path="/edit-activation-steps/:id" element={<EditActivationSteps />} />
          <Route path="/deals-management" element={<DealsManagement />} />
          <Route path="/user-access-management" element={<UserAccessManagement />} />
          <Route path="/create-user-access-management" element={<CreateUserAccess />} />
          <Route path="/merchant-management" element={<MerchantManagement />} />
          <Route path="/merchant-details" element={<MerchantDetails />} />
          <Route path="/listing-details" element={<ListingDetails />} />
          <Route path="/commission-configuration" element={<CommissionConfiguration />} />
          <Route path="/esim/share" element={<EsimShare />} />
          <Route path="/:slug" element={<GiveawayRedirect campaignLanding />} />
          <Route path="*" element={<NotFoundPage />} />
          </Routes>

          {/* --- Website Coming Soon Popup --- */}
          <ConditionalGlobalPopup />
          <CartFloatingButton />

          {/* </InitAmadeusToken> */}
          </CartProvider>
        </MaintenanceGate>
      </Router>
    </>
  );
}

export default App;
